<div class="card card-widget">
    <h6 class="card-header">
        {{title}} 
    </h6>  
    <div class="card-body">
        <ng-template [ngIf]="isLoading">
            <i class='fas fa-spinner fa-pulse' aria-hidden='true'></i> Carregando
        </ng-template>

        <ng-template [ngIf]="!isLoading && chart">
            <div class="tipos-classificacoes">
                <div class="tipo-classificacao" *ngFor="let tipoClassificacao of chart.tiposClassificacoes">
                    <div class="tipo-classificacao-side">
                        <sgt-cliente-segmento-card-chart
                            [nome]="tipoClassificacao.nome"
                            [quantidadeClientes]="tipoClassificacao.classificacoes?.length"
                            [percParticipacao]="null">
                        </sgt-cliente-segmento-card-chart>
                    </div>
    
                    <div class="classificacoes">
                        <div class="classificacao" *ngFor="let classificacao of tipoClassificacao.classificacoes">
                            <sgt-cliente-segmento-card-chart
                                [nome]="classificacao.nome"
                                [quantidadeClientes]="classificacao.quantidadeClientes"
                                [percParticipacao]="classificacao.percParticipacao">
                            </sgt-cliente-segmento-card-chart>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
</div>
